module.exports = __webpack_public_path__ + "static/home_item_a-85e85ff7a5aec700fc543e22918e5368.jpg";